<template>
  <div class="container-fluid py-4 text-left">
    <div class="row">
      <div class="col-12">
        <div class="card mb-4 border-0 shadow-sm bg-white rounded-lg">
          <div class="card-body d-flex align-items-center">
            <div class="avatar-circle shadow-sm mr-3">
              {{ user.fullname ? user.fullname.charAt(0) : 'U' }}
            </div>
            <div>
              <h4 class="mb-0 font-weight-bold text-dark">{{ user.fullname || 'Cargando...' }}</h4>
              <b-badge pill variant="primary" class="px-3">{{ user.rol || 'Consultando...' }}</b-badge>
            </div>
          </div>
        </div>

        <div class="row">
          <div class="col-lg-7">
            <div class="card shadow-sm mb-4 border-0">
              <div class="card-header bg-white d-flex justify-content-between align-items-center py-3">
                <h6 class="mb-0 font-weight-bold text-muted small"><i class="fas fa-user mr-2 text-primary"></i>INFORMACIÓN GENERAL</h6>
                <b-button size="sm" variant="orange" class="text-white px-3 border-0" @click="editarInfo">Editar</b-button>
              </div>
              <div class="card-body">
                <div class="row">
                  <div class="col-md-6 mb-3">
                    <label class="text-muted small d-block font-weight-bold">CORREO</label>
                    <span class="text-dark">{{ user.email }}</span>
                  </div>
                  <div class="col-md-6 mb-3">
                    <label class="text-muted small d-block font-weight-bold">ESTATUS</label>
                    <b-badge variant="success" class="px-2">{{ user.admin_user_status_label }}</b-badge>
                  </div>
                </div>
              </div>
            </div>

            <div class="card shadow-sm border-0 bg-purple-gradient text-white">
              <div class="card-body d-flex justify-content-between align-items-center">
                <div>
                  <h6 class="font-weight-bold mb-1">Seguridad de cuenta</h6>
                  <p class="small mb-0 opacity-80">Cambiar la contraseña directamente en el sistema.</p>
                </div>
                <b-button variant="white" class="px-4 font-weight-bold" @click="abrirModalPassword">Cambiar Clave</b-button>
              </div>
            </div>
          </div>

          <div class="col-lg-5">
            <div class="card shadow-sm border-0">
              <div class="card-header bg-white py-3">
                <h6 class="mb-0 font-weight-bold text-primary"><i class="fas fa-shield-alt mr-2"></i>Asignación de Rol</h6>
              </div>
              <div class="list-group list-group-flush custom-scrollbar" style="max-height: 500px; overflow-y: auto;">
                <label
                  v-for="role in roleOptions"
                  :key="role.admin_role_id"
                  :class="['list-group-item list-group-item-action border-0 p-3 mb-1 rounded-lg transition-all',
                            Number(selectedRole) === Number(role.id) ? 'active-role' : '']"
                  style="cursor: pointer;"
                >
                  <div class="d-flex align-items-center w-100">
                    <div class="custom-control custom-radio custom-control-inline mr-0">
                      <input
                        type="radio"
                        :id="`role-${role.id}`"
                        v-model="selectedRole"
                        :value="Number(role.id)"
                        class="custom-control-input"
                        @change="confirmarCambioRol(role)"
                      >
                      <label class="custom-control-label" :for="`role-${role.id}`"></label>
                    </div>
                    <div class="ml-2 flex-grow-1">
                      <div class="d-flex justify-content-between align-items-center">
                        <span class="font-weight-bold">{{ role.name }}</span>
                        <i v-if="Number(selectedRole) === Number(role.id)" class="fas fa-check-circle"></i>
                      </div>
                      <p class="small mb-0 opacity-75">{{ role.description }}</p>
                    </div>
                  </div>
                </label>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <b-modal id="modal-edit-info" title="Editar Información" centered @ok="guardarEdicion">
      <div class="p-2">
        <b-form-group label="NOMBRE(S)" label-class="small font-weight-bold">
          <b-form-input v-model="tempUser.name" class="form-control-lg"></b-form-input>
        </b-form-group>
         <b-form-group label="Apellido Paterno" label-class="small font-weight-bold">
          <b-form-input v-model="tempUser.last_name_1" class="form-control-lg"></b-form-input>
        </b-form-group>
         <b-form-group label="Apellido Materno" label-class="small font-weight-bold">
          <b-form-input v-model="tempUser.last_name_2" class="form-control-lg"></b-form-input>
        </b-form-group>
        <b-form-group label="CORREO ELECTRÓNICO" label-class="small font-weight-bold">
          <b-form-input v-model="tempUser.email" type="email"></b-form-input>
        </b-form-group>
      </div>
      <template #modal-footer="{ ok, cancel }">
        <b-button variant="link" class="text-muted" @click="cancel()">Cancelar</b-button>
        <b-button variant="primary" class="px-4" :disabled="loading" @click="ok()">
          <b-spinner small v-if="loading"></b-spinner> Guardar Cambios
        </b-button>
      </template>
    </b-modal>

    <b-modal id="modal-password" title="Nueva Contraseña" centered hide-footer>
      <div class="text-center p-3">
        <div class="icon-circle bg-light-purple text-purple mb-3 mx-auto">
          <i class="fas fa-lock fa-2x"></i>
        </div>
        <p class="text-muted small">Escribe la nueva contraseña para el usuario.</p>
        <b-input-group class="mb-4">
          <b-form-input :type="showPass ? 'text' : 'password'" v-model="newPassword" class="text-center" placeholder="Mínimo 6 caracteres"></b-form-input>
          <template #append>
            <b-input-group-text @click="showPass = !showPass" style="cursor: pointer">
              <i :class="['fas', showPass ? 'fa-eye-slash' : 'fa-eye']"></i>
            </b-input-group-text>
          </template>
        </b-input-group>
        <b-button variant="purple" block class="rounded-pill py-2 shadow-sm" :disabled="newPassword.length < 6 || loading" @click="updatePassword">
          <b-spinner small v-if="loading"></b-spinner> Actualizar Contraseña
        </b-button>
      </div>
    </b-modal>

    <b-modal id="modal-confirm-role" title="Confirmar Cambio" centered @ok="ejecutarCambioRol" @cancel="cancelarCambio" ok-title="Sí, cambiar" cancel-title="Cancelar">
      <div class="text-center py-3">
        <i class="fas fa-exclamation-triangle fa-3x text-warning mb-3"></i>
        <p>¿Confirmas el cambio al rol de <b>{{ pendingRole.name }}</b>?</p>
      </div>
    </b-modal>
  </div>
</template>

<script>
import axiosAdelaService from '@/axios/axiosAdelaService'
import moment from 'moment'

export default {
  data () {
    return {
      user: {},
      tempUser: {},
      roleOptions: [],
      selectedRole: null,
      currentRole: null,
      pendingRole: {},
      newPassword: '',
      showPass: false,
      loading: false
    }
  },
  methods: {
    async initData () {
      try {
        const resRoles = await axiosAdelaService.post('/rolesselect', {})
        this.roleOptions = resRoles.data

        // Usamos el ID que ya debería estar en this.user gracias a created()
        const resUser = await axiosAdelaService.post('/getUserInfo', { user_id: this.user.user_admin_id })
        if (resUser.status === 200) {
          this.user = resUser.data
          this.user.created_at = moment(this.user.created_at).format('DD/MM/YYYY')

          this.currentRole = Number(this.user.role_id)
          this.selectedRole = this.currentRole
        }
      } catch (e) { console.error(e) }
    },
    confirmarCambioRol (role) {
      if (Number(role.id) === Number(this.currentRole)) return
      this.pendingRole = role
      this.$bvModal.show('modal-confirm-role')
    },
    cancelarCambio () {
      this.selectedRole = this.currentRole
    },
    async ejecutarCambioRol () {
      this.loading = true
      try {
        const res = await axiosAdelaService.post('/updateUserRole', {
          user_admin_id: this.user.user_admin_id,
          role_id: this.pendingRole.id
        })
        if (res.status === 200) {
          this.currentRole = Number(this.pendingRole.id)
          this.selectedRole = this.currentRole
          this.user.rol = this.pendingRole.name
          this.$toastedPush({ message: 'Rol actualizado', type: 'success' })
        }
      } catch (e) {
        this.selectedRole = this.currentRole
        alert('Error al actualizar')
      } finally { this.loading = false }
    },
    editarInfo () {
      console.log('Usuario a editar:', this.user)
      this.tempUser = { ...this.user }
      this.$bvModal.show('modal-edit-info')
    },
    async guardarEdicion (bvEvt) {
      bvEvt.preventDefault()
      this.loading = true
      try {
        const res = await axiosAdelaService.post('/updateUserInfo', {
          ...this.tempUser
        })
        if (res.status === 200) {
          this.user.fullname = this.tempUser.fullname
          this.user.email = this.tempUser.email
          this.$bvModal.hide('modal-edit-info')
          this.$toastedPush({ message: 'Información actualizada', type: 'success' })
          this.initData()
        }
      } catch (e) {
        alert('Error al guardar')
      } finally { this.loading = false }
    },
    abrirModalPassword () {
      this.newPassword = ''
      this.showPass = false
      this.$bvModal.show('modal-password')
    },
    async updatePassword () {
      this.loading = true
      try {
        await axiosAdelaService.post('/updatePassword', {
          user_admin_id: this.user.user_admin_id,
          password: this.newPassword
        })
        this.$bvModal.hide('modal-password')
        this.$toastedPush({ message: 'Contraseña actualizada', type: 'success' })
      } catch (e) {
        alert('Error al cambiar contraseña')
      } finally { this.loading = false }
    }
  },
  created () {
    // ESTO ES LO QUE HACÍA QUE NO SE VIERAN LOS DATOS:
    const row = this.$_.get(this.$route, 'params.row', null)
    if (row) {
      this.user = { ...row }
      // Aseguramos que el ID de rol se asigne desde el inicio
      this.currentRole = Number(row.role_id || row.admin_role_id)
      this.selectedRole = this.currentRole
    }
  },
  mounted () {
    this.initData()
  }
}
</script>

<style scoped>
.avatar-circle {
  width: 55px; height: 55px;
  background: linear-gradient(45deg, #007bff, #00c6ff);
  color: white; border-radius: 50%;
  display: flex; align-items: center; justify-content: center;
  font-size: 22px; font-weight: bold;
}
.active-role {
  background-color: #007bff !important;
  color: white !important;
  border-left: 5px solid #0056b3 !important;
  transform: translateX(5px);
}
.active-role .opacity-75 { color: #f0f0f0 !important; }
.transition-all { transition: all 0.3s ease; }
.btn-orange { background: #ff8800; border: none; }
.bg-purple-gradient { background: linear-gradient(135deg, #6f42c1, #8e44ad); }
.btn-purple { background: #6f42c1; color: white; border: none; }
.btn-white { background: white; color: #6f42c1; border: none; }
.icon-circle { width: 60px; height: 60px; border-radius: 50%; display: flex; align-items: center; justify-content: center; }
.bg-light-purple { background: #f3e5f5; }
.text-purple { color: #6f42c1; }
</style>
